import UrgentMessageModal from './UrgentMessageModalTS'

export default UrgentMessageModal
